import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';
import { ESTypeMap } from 'modules/workflows/types';
import { WorkflowsRootState } from '../ducks.types';
import { parseMappings } from '../reducers/utils';

export const getEsFields = (state: WorkflowsRootState) => state.workflow?.esFields;
export const getTopLevelCustomEvents = (state: WorkflowsRootState) =>
  state.workflow?.topLevelCustomEvents || [];
export const getCustomEventMappings = (state: WorkflowsRootState) =>
  state.workflow?.esFields?.customEventMappings;
export const getUserMappings = (state: WorkflowsRootState) =>
  state.workflow?.esFields?.userMappings;
export const getFieldMappings = (state: WorkflowsRootState) =>
  state.workflow?.esFields?.mappings || {};
export const getEventFieldMappings = createSelector(
  [getUserMappings, getCustomEventMappings, getFieldMappings],
  (userMappings = [], customEventMappings = [], eventFieldMappings): ESTypeMap => {
    const consolidatedMappings = eventFieldMappings;

    if (userMappings.length > 0) {
      consolidatedMappings.user = parseMappings(userMappings);
    }
    if (customEventMappings.length > 0) {
      consolidatedMappings.customEvent = parseMappings(customEventMappings);
    }
    return consolidatedMappings;
  },
);

export const getAreMappingsPopulated = createSelector(
  [getUserMappings, getCustomEventMappings, getFieldMappings],
  (userMappings, customEventMappings, eventFieldMappings): boolean =>
    Array.isArray(userMappings) &&
    Array.isArray(customEventMappings) &&
    !isEmpty(eventFieldMappings),
);

export const getIsFetchingEventFieldMappings = (state: WorkflowsRootState) =>
  state.workflow?.isFetchingEventFieldMappings;
